import React from 'react';
import { observable } from "mobx";
import moment from "moment";
import { formatarReal, formatarDataCustomHTMLSemHora, formatarRealSemCifrao } from '../../../../utils/formatar';
import { buscaSemResultado, buscaFiltrarVazio } from '../../../../utils/mensagens';
import _ from 'lodash';
import { sortCaret } from '../../../comum/components/Icones';
import NotaFiscalFaturamentoService from "../../../../services/NotaFiscalFaturamentoService";
import FileSaver from 'file-saver'

export default class NotaFiscalFaturamentoStore {

    @observable dadosConsulta
    @observable dadosProtocolos
    @observable dadosListaAnexos
    @observable dadosProtocoloAnexos
    @observable dadosItens;

    @observable naviosFiltro
    @observable navioSelecionado
    @observable clientesFiltro
    @observable clienteSelecionado

    @observable atualizado
    @observable loading;


    constructor() {
        /* Dados Consulta */
        this.dadosConsulta = [];
        this.dadosProtocolos = [];
        this.dadosListaAnexos = [];
        this.dadosProtocoloAnexos = [];
        this.dadosItens = [];

        this.atualizado = true;
        this.loading = false;

        /* Filtros */
        this.filtroSelecionado = [];
        this.filtroCompleto = false;
        this.filtrado = false;
        this.dataInicial = null;
        this.dataFinal = null;
        this.tableMessage = buscaFiltrarVazio;

        /* Serviços */
        this.notaFaturamentoService = new NotaFiscalFaturamentoService();

        this.filtraPeriodo = this.filtraPeriodo.bind(this);
    };

    setFiltroSelecionado(campo, valor) {
        if (valor) {
            this.filtroSelecionado[campo] = valor;
        }
        else {
            this.filtroSelecionado = _.omit(this.filtroSelecionado, campo)
        }
    };

    setNavio = (itemSelected) => {
        if (itemSelected) {
            this.navioSelecionado = itemSelected;
            this.setFiltroSelecionado("operacao", itemSelected.value);
        }
        else {
            this.navioSelecionado = {};
            this.setFiltroSelecionado("operacao");
        }
    };

    setCliente = (itemSelected) => {
        if (itemSelected) {
            this.clienteSelecionado = itemSelected
            this.setFiltroSelecionado("cliente", itemSelected.value);
        } else {
            this.clienteSelecionado = {}
            this.setFiltroSelecionado("cliente");
        }
    }

    inicializarFiltros = async () => {
        this.atualizado = false;
    }

    filtraPeriodo = (bool) => {
        if (bool) {
            this.dataInicial = moment().subtract(14, 'day').format("DD/MM/YYYY");
            this.setFiltroSelecionado("dataEmissaoInicial", this.dataInicial);
            this.dataFinal = moment().add(0, 'day').format("DD/MM/YYYY");
            this.setFiltroSelecionado("dtFidataEmissaoFinalm", this.dataFinal);
        }
        else {
            this.dataInicial = null;
            this.setFiltroSelecionado("dataEmissaoInicial");
            this.dataFinal = null;
            this.setFiltroSelecionado("dataEmissaoFinal");
        }

    }

    setDataInicio = (value) => {
        if (this.filtroCompleto) {
            this.dataInicial = value;
            this.setFiltroSelecionado("dataEmissaoInicial", this.dataInicial);
        }
    };

    setDataFim = (value) => {
        if (this.filtroCompleto) {
            this.dataFinal = value;
            this.setFiltroSelecionado("dataEmissaoFinal", this.dataFinal);
        }
    };


    colunasNotaFaturamento = [
        {
            dataField: "Id",
            hidden: true
        },
        {
            dataField: "Numero",
            text: "Nota",
            sort: true,
            sortCaret: sortCaret,
            headerStyle: { width: "8%", textAlign: "left" }
        },
        {
            dataField: "DataEmissao",
            text: "Data Emissão",
            sort: true,
            sortCaret: sortCaret,
            headerStyle: { width: "12%", textAlign: "center" },
            formatter: formatarDataCustomHTMLSemHora,
            align: (cell, row, rowIndex, colIndex) => { return 'center' }
        },
        {
            dataField: "DataVencimento",
            text: "Data Vencimento",
            sort: true,
            sortCaret: sortCaret,
            headerStyle: { width: "12%", textAlign: "center" },
            formatter: formatarDataCustomHTMLSemHora,
            align: (cell, row, rowIndex, colIndex) => { return 'center' }
        },
        {
            dataField: "Cnpj",
            text: "CNPJ",
            sort: true,
            sortCaret: sortCaret,
            headerStyle: { width: "15%", textAlign: "center" },
            align: (cell, row, rowIndex, colIndex) => { return 'center' },
        },
        {
            dataField: "Cliente",
            text: "Cliente",
            sort: true,
            sortCaret: sortCaret,
            headerStyle: { width: "36%", textAlign: "left" }
        },
        {
            dataField: "Valor",
            text: "Valor Nota",
            sort: true,
            sortCaret: sortCaret,
            headerStyle: { width: "10%", textAlign: "right" },
            align: (cell, row, rowIndex, colIndex) => { return 'right' },
            formatter: formatarReal
        }
    ]

    colunasNotaFaturamentoItem = [
        {
            dataField: "Id",
            hidden: true
        },
        /*{
            dataField: "Documento",
            text: "Nº Booking / BL",
            headerStyle: { textAlign: "left" }
        },*/
        {
            dataField: "Container",
            text: "Container",
            headerStyle: { width: "13%", textAlign: "left" }
        },
        {
            dataField: "Descricao",
            text: "Descrição",
            headerStyle: { width: "60%", textAlign: "left" }
        },
        {
            dataField: "Quantidade",
            text: "Qtde",
            headerStyle: { width: "7%", textAlign: "center" },
            align: (cell, row, rowIndex, colIndex) => { return 'center' },
        },
        {
            dataField: "Valor",
            text: "Valor",
            headerStyle: { width: "10%", textAlign: "right" },
            align: (cell, row, rowIndex, colIndex) => { return 'right' },
            formatter: formatarReal
        }
    ]

    colunasAnexosFaturamento = [
        { titulo: "", field: ["Nome"], tamanhoCol: 2, id: "F1", hidden: false },
    ];

    carregarDadosConsulta = async () => {
        try {
            this.filtrado = true;
            this.loading = true;
            this.dadosConsulta = [];
            this.dadosProtocoloAnexos = [];
            let response = await this.notaFaturamentoService.listar(this.filtroSelecionado);
            if (response.data && response.data.length > 0) {
                this.dadosConsulta = response.data;
                this.atualizado = true;
                this.loading = false;

                // this.dadosConsulta.forEach(dado => {
                //     if(dado.Id) {
                //         //dado.dadosItens = this.getItens(this.dadosConsulta.Id);
                //         this.notaFaturamentoService.listarItens(dado.Id).then(response => {
                //             if(response && response.data) {
                //                 dado.dadosItens = response.data;
                //             } else {
                //                 datas.dadosItens = []
                //             }
                //         }).catch(err => console.error(err));
                //     }
                // });

                // console.log(this.dadosConsulta);
            }
            else {
                this.dadosConsulta = [];
                this.dadosProtocolos = [];
                this.dadosListaAnexos = [];
                this.tableMessage = buscaSemResultado;
                this.loading = false;
            }
        }
        catch (error) {
            console.log(error);
        }
        finally{
            this.loading = false;
        }
    }

    getItens = async (notaId) => {
        try {
            const { data } = await this.notaFaturamentoService.listarItens(notaId)
            if (data && Array.isArray(data)) return data
        } catch (error) {
            console.error('NotaFiscalFaturamentoStore', error)
        }
        return []
    }

    getAnexos = async (notaId) => {
        try {
            const { data } = await this.notaFaturamentoService.listarAnexos(notaId)
            if (data && Array.isArray(data)) return data
        } catch (error) {
            console.error('NotaFiscalFaturamentoStore', error)
        }
        return []
    }

    naviosOptions = async (label = null) => {
        const response = await this.notaFaturamentoService.listarNavios(label);
        if (response.data && response.data.length > 0) {
            return response.data.map(c => ({ label: c.Texto, value: c.Id }))
        }
    }

    clientesOptions = async (label = null) => {
        const response = await this.notaFaturamentoService.listarClientes(label);
        if (response.data && response.data.length > 0) {
            return response.data.map(c => ({ label: c.Texto, value: c.Id }))
        }
    }

    downloadFileSaver = async (ProtEletRelNfRepId, link = null) => {
        try {

            if (link) return FileSaver.saveAs(link)

            const response = await this.notaFaturamentoService.downloadAnexo(ProtEletRelNfRepId)
            if (response.status === 200) {
                const { file, filename } = response.data
                FileSaver.saveAs(file, filename)
            }
            else
                console.log(response)
        }
        catch (err) {
            console.log(err);
        }
    }

    columnsToExport = [
        { text: 'Número', dataField: 'Numero' },
        { text: 'Data Emissão', dataField: 'DataEmissao'},
        { text: 'Data Vencimento', dataField: 'DataVencimento' },
        { text: 'CNPJ', dataField: 'Cnpj' },
        { text: 'Cliente', dataField: 'Cliente' },
        { text: 'Valor', dataField: 'Valor', format: (v) => { return formatarRealSemCifrao(v) } },
    ]
}


// WEBPACK FOOTER //
// ./src/modules/faturamento/notafiscal/stores/NotaFiscalFaturamentoStore.js